<div class="flex flex-col">
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ data.externalWorkshiftId }} - {{ data.userName }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <mat-list class="p-8">
        @for (event of events(); track event.queueTimestamp) {
            <mat-list-item>
              <span matListItemTitle>{{ ('services.dialog.workshiftUserEvents.' + event.event) | transloco }}</span>
              <span matListItemLine>{{ event.queueTimestamp | localizeDate: 'HH:mm:ss' }}</span>
            </mat-list-item>
        } @empty {
            <p class="font-semibold tracking-tight leading-tight px-8 py-4">{{ 'services.dialog.workshiftUserEvents.noEvents' | transloco }}</p>
        }
      </mat-list>
</div>
